import { Settings } from "react-slick";

const SLIDER_TRANSITION_SPEED_MS = 500;

export const SLICK_LAZY_LOAD_ON_DEMAND = "ondemand" as const;

/**
 * With `infinite` enabled and a single slide, react-slick still renders the
 * pre/post clones but sizes the track for one slide only. The cloned slides then
 * wrap inside the track and stack vertically instead of forming a carousel.
 * Looping and arrows are only meaningful with more than one photo anyway.
 */
export function getPhotosSliderSettings(photoCount: number): Settings {
  const hasMultiplePhotos = photoCount > 1;

  return {
    arrows: hasMultiplePhotos,
    infinite: hasMultiplePhotos,
    speed: SLIDER_TRANSITION_SPEED_MS,
    slidesToShow: 1,
    slidesToScroll: 1,
    // react-slick replaces unloaded slides with an empty <div />, so <img src>
    // is not mounted (and S3 is not hit) until the slide is needed.
    // Do not use jQuery Slick's data-lazy attribute here — react-slick never copies it to src.
    lazyLoad: SLICK_LAZY_LOAD_ON_DEMAND,
  };
}
